import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export default function ReelMarquee() {
  const reels = [
    "images/reels/reel1.gif",
    "images/reels/reel2.gif",
    "images/reels/reel3.gif",
    "images/reels/reel4.gif",
    "images/reels/reel5.gif",
    "images/reels/reel6.gif",
    "images/reels/reel7.gif",
    "images/reels/reel8.gif",
    "images/reels/reel9.gif",
    "images/reels/reel10.gif",
  ];

  // duplicate for perfect infinite loop
  const loopItems = [...reels, ...reels];

  return (
    <div className="reel-marquee">
      <Swiper
        modules={[Autoplay]}
        spaceBetween={20}
        slidesPerView={"auto"}
        loop={true}
        allowTouchMove={true}
        speed={1500}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
        }}
      >
        {loopItems.map((src, i) => (
          <SwiperSlide key={i} style={{ width: "200px" }}>
            <div className="reel-box">
              <img src={src} alt="reel" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
